interface Props {
  warnings: string[]
  error: string | undefined
  onDismiss: () => void
}

/** What the last mutation did, and what it did to data you were not looking at.
 *
 *  Rendered as a block that stays until dismissed rather than a toast. These
 *  are the sentences that tell an operator their edit rewrote every past
 *  completeness percentage, or that a channel now reads as two different
 *  parameters either side of today. None of that is recoverable from the
 *  screen once it has faded.
 */
export function Warnings({ warnings, error, onDismiss }: Props) {
  if (!warnings.length && !error) return null

  return (
    <div className={`notice ${error ? 'notice-error' : 'notice-warn'}`}>
      <div className="notice-head">
        <strong>{error ? 'Not applied' : 'Applied: Read This'}</strong>
        <button className="link" onClick={onDismiss}>dismiss</button>
      </div>
      {error && <p>{error}</p>}
      {warnings.length > 0 && (
        <ul>
          {warnings.map((warning) => <li key={warning}>{warning}</li>)}
        </ul>
      )}
    </div>
  )
}
